import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.footer = document.querySelector("footer")
    if (!this.footer) return

    this.check = () => {
      const rect = this.footer.getBoundingClientRect()
      const footerVisible = rect.top < window.innerHeight
      this.element.style.opacity = footerVisible ? "0" : "1"
      this.element.style.pointerEvents = footerVisible ? "none" : "auto"
    }

    window.addEventListener("scroll", this.check, { passive: true })
    this.check()
  }

  disconnect() {
    if (this.check) window.removeEventListener("scroll", this.check)
  }

  scroll() {
    window.scrollBy({ top: window.innerHeight * 0.8, behavior: "smooth" })
  }
}
